import { createSelector } from 'reselect'

const sortCategoriesByName = (categoryA, categoryB) => {
  return categoryA.value?.name
    ?.replace(/\W+/g, '')
    ?.localeCompare(categoryB.value?.name?.replace(/\W+/g, ''))
}
const getCreatedUnitNo = ({ unitNo }) => unitNo.createdUnitNo
const getCreatingUnitNo = ({ unitNo }) => unitNo.loading
const getUnitNumbers = ({ unitNo }) => unitNo.records

const mapUnitNoFields = (createdUnitNo) => {
  return createdUnitNo
}

const unitNoSelectors = {
  getCreatedUnitNo: createSelector([getCreatedUnitNo], (createdUnitNo) => {
    if (!createdUnitNo || !Object.keys(createdUnitNo).length) {
      return {}
    }
    return mapUnitNoFields(createdUnitNo)
  }),

  getCreatingUnitNo: createSelector([getCreatingUnitNo], (creatingUnitNo) => {
    return creatingUnitNo
  }),

  getUnitNumberOptions: createSelector([getUnitNumbers], (unitNumbers) => {
    return [...unitNumbers].sort(sortCategoriesByName)
  }),
}

export default unitNoSelectors
